import React from 'react'

export default ({ node }) => (
  <div>
    {Array.isArray(node.extras.number)
      ? node.extras.number.map((num, key) => <div key={key}>{num}</div>)
      : node.extras.number}
  </div>
)



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/ForwardCall/ForwardCallDisplay.jsx